import { statusMapper } from "screens/tickets/helpers/mapper";
import { CalendarDaysIcon, ClockIcon } from "../../images/icons";
import { formatDate, formatTime } from "services/helpers/formatter";
import { normalizeTicketType } from "screens/tickets/helpers/mapper";
import ReactLoading from "react-loading";
import MessageCard from "./messageCard";
import { Card, Button } from "@biteship/atom";
import { useState, useRef } from "react";
import { createTicketComment, getTicket, uploadContentBlob } from "store/action/ticket";
import { singleAPItoData } from "screens/tickets/helpers/formatter";
import ModalImages from "../createTicket/modalImages";
import DOMPurify from "dompurify";
import TextEditor from "../textEditor";
import sanitizeHtml from 'sanitize-html';
import { generateReference } from "@lib/reference";
// import { trackEvent } from "services/analytics";

export default function DetailTicketView(props) {
  const { title, fontClass, bgClass } = statusMapper(props.ticket?.status);
  const { secondCategory } = normalizeTicketType(props.ticket?.type || "");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [activeImage, setActiveImage] = useState(0);
  const detailEndRef = useRef(null);

  const scrollToBottom = () => {
    detailEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const makeContent = async (commentRef) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(message, 'text/html');
    const images = doc.querySelectorAll('img');
    const base64Images = Array.from(images)
      .filter(img => img.src.startsWith('data:image/'))
      .map(img => img.src);

    let content = message;

    for (let i = 0; i < base64Images.length; i++) {
      const image = base64Images[i];
      const response = await fetch(image);
      const blob = await response.blob();
      const result = await uploadContentBlob(blob, commentRef);
      content = content.replace(image, result.content.url || "");
    };

    return content;
  }

  const onSubmitComment = async (id) => {
    try {
      setLoading(true);
      const commentRef = generateReference("comment");
      const content = await makeContent(commentRef);
      const result = await createTicketComment(id, {
        content: sanitizeHtml(content, {
          allowedTags: sanitizeHtml.defaults.allowedTags.concat(["img"])
        }),
        ref: commentRef,
      });
      if (result.success) {
        const result = await getTicket(id);
        if (result.success) props.setTicket(singleAPItoData(result));
      } else {
        alert("Gagal mengirim komentar. Silahkan coba kembali");
      }
      setMessage("");
      setLoading(false);
      scrollToBottom();
    } catch (error) {
      setLoading(false);
      alert("Gagal mengirim komentar. Silahkan coba kembali");
      console.log(error);
    }
  };

  const sanitizedDescription = DOMPurify
    .sanitize(props?.ticket?.description || "")
    .replace(/<p>/g, "<p class='mb-0' >") // p tag is styled with bottom margin globally, but the content here, each line is using p tag
    .replace(/<pre/g, `<div class="
        ql-editor
        bg-gray-200
        border
        border-gray-300
        p-2
        rounded
        h-auto
        my-2
      "><pre`)
    .replace(/<\/pre>/g, `</pre></div>`)
    .replace(/<img/g, `<img style="max-height: 200px;"`);

  return (
    <div className="w-full md:w-2/3 border-t overflow-auto">
      {props.loading ? (
        <div className="flex justify-center pt-12">
          <ReactLoading type="spin" color={"#6E32BF"} height={48} width={40} />
        </div>
      ) : (
        props.ticket.id && (
          <div className="relative mb-12">
            <div className="p-4 md:px-6 bg-white flex justify-between border-b space-x-2">
              <div>
                <div className="text-base font-bold text-gray-900">{props.ticket.title}</div>
                <div className="text-primary">{props.ticket.id.toUpperCase()}</div>
              </div>
              <div>
                <div
                  className={`py-1 px-3 ${bgClass} ${fontClass} font-bold text-xxs rounded-lg min-w-[65px] text-center`}
                >
                  {title}
                </div>
              </div>
            </div>
            <div className="p-4 md:px-6 bg-white border-b space-y-4">
              <div className="flex justify-between space-x-4">
                <div className="text-gray-900 space-y-2 text-xs">
                  <p className="text-gray-700 text-xs whitespace-nowrap">Tanggal Dibuat</p>
                  <div className="flex items-center">
                    <CalendarDaysIcon
                      className="w-4 flex-shrink-0 text-primary-900 mr-2"
                      aria-hidden
                    />
                    {formatDate(props.ticket.createdAt)}
                  </div>
                  <div className="flex items-center">
                    <ClockIcon className="w-4 flex-shrink-0 text-primary-900 mr-2" aria-hidden />
                    {formatTime(props.ticket.createdAt)}
                  </div>
                </div>
                <div className="text-gray-900 space-y-2 text-xs">
                  <p className="text-gray-700 text-xs whitespace-nowrap">No Resi</p>
                  <p className="text-xs">{props.ticket.orderIds.join(", ").toUpperCase() || "-"}</p>
                </div>
                <div className="text-gray-900 space-y-2 text-xs hidden md:block">
                  <p className="text-gray-700 text-xs whitespace-nowrap">Kategori Kendala 2</p>
                  <p className="text-xs">{secondCategory}</p>
                </div>
                <div className="text-gray-900 space-y-2 text-xs">
                  <p className="text-gray-700 text-xs whitespace-nowrap">Dokumen Pendukung</p>
                  {props.ticket.supportImageLinks.length ? (
                    <div
                      className="text-primary text-xs underline cursor-pointer"
                      onClick={() => {
                        // trackEvent("Ticket PreviewFile");
                        setActiveImage(0);
                        setModal(true);
                      }}
                      aria-hidden
                    >
                      Lihat Foto
                    </div>
                  ) : (
                    <p className="text-xs">-</p>
                  )}
                </div>
              </div>
              <div className="text-gray-900 space-y-2 text-xs md:hidden">
                <p className="text-gray-700 text-xs whitespace-nowrap">Kategori Kendala 2</p>
                <p className="text-xs">{secondCategory}</p>
              </div>
            </div>
            <div className="p-4 md:px-6 bg-white space-y-2 border-b">
              <p className="text-gray-800 text-xs font-bold">Detail Kendala</p>
              <div className="p-0 ql-editor" dangerouslySetInnerHTML={{ __html: sanitizedDescription }}></div>
            </div>
            <div className="pt-4 px-6 bg-gray-200">
              <div className="font-bold mb-4 text-gray-900">Kolom Komentar</div>
              {props.ticket.comments.length > 0 ? (
                <div className="space-y-4">
                  {props.ticket.comments.map((i, idx) => (
                    <MessageCard comment={i} key={idx} />
                  ))}
                </div>
              ) : (
                <div className="flex justify-center text-gray-800 text-xs pb-4">
                  Belum Ada Komentar
                </div>
              )}
            </div>
            {props.ticket.status === "solved" ? (
              <div className="flex justify-center text-gray-800 text-xs pt-4">
                Tiket Sudah Ditutup
              </div>
            ) : (
              <div className="px-6 py-4 bg-gray-200">
                <Card className="border">
                  <div>
                    <TextEditor
                      placeholder="Masukkan Komentarmu Disini"
                      setValue={(e) => setMessage(e)}
                      value={message}
                    />
                  </div>
                  <div className="px-5 py-2 flex justify-end bg-gray-200 border-t">
                    <Button
                      title={
                        <div className={`font-bold ${!message && "text-neutral-60"}`}>
                          Kirim Komentar
                        </div>
                      }
                      className={`justify-center ${!message && "bg-neutral-40 hover:bg-neutral-40"
                        }`}
                      onClick={() => onSubmitComment(props.ticket.id)}
                      loading={loading}
                      loadingTitle={<div className="font-bold ml-2">Mengirim Komentar</div>}
                      disabled={!message}
                    />
                  </div>
                </Card>
              </div>
            )}
            <ModalImages
              from="detail"
              images={props.ticket.supportImageLinks}
              activeImage={activeImage}
              show={modal}
              setActiveImage={setActiveImage}
              onClose={() => setModal(false)}
            />
            <div ref={detailEndRef}></div>
          </div>
        )
      )}
    </div>
  );
}
